import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import useLenis from "./hooks/useLenis";
import Grain from "./components/eclipse/Grain";
import Header from "./components/eclipse/Header";
import Hero from "./components/eclipse/Hero";
import Manifesto from "./components/eclipse/Manifesto";
import Nokuji from "./components/eclipse/Nokuji";
import Surprises from "./components/eclipse/Surprises";
import Lemfi from "./components/eclipse/Lemfi";
import Lineup from "./components/eclipse/Lineup";
import FinalCTA from "./components/eclipse/FinalCTA";
import Footer from "./components/eclipse/Footer";
import CountdownBanner from "./components/eclipse/CountdownBanner";
import AdminLogin from "./pages/AdminLogin";
import AdminDashboard from "./pages/AdminDashboard";

function Eclipse() {
  useLenis();
  return (
    <div className="relative bg-[#09090b]">
      <Grain />
      <Header />
      <main>
        <Hero />
        <Manifesto />
        <Nokuji />
        <Surprises />
        <Lemfi />
        <Lineup />
        <FinalCTA />
      </main>
      <Footer />
      <CountdownBanner />
    </div>
  );
}

function App() {
  return (
    <div className="App">
      <Toaster theme="dark" position="bottom-right" richColors />
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Eclipse />} />
          <Route path="/admin/login" element={<AdminLogin />} />
          <Route path="/admin" element={<AdminDashboard />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
